import {Component} from "react";
import appLib from "../../../libs/appLib.mjs";
import {Button, ButtonGroup, Form, Input, InputGroup} from "reactstrap";
import TextLabel from "../../../controls/TextLabel.mjs";
import TrashIcon from "../../../media/assets/TrashIcon.mjs";
import LockOffIcon from "../../../media/assets/LockOffIcon.mjs";
import Glob from "../../../libs/Glob.mjs";
import MailIcon from "../../../media/assets/MailIcon.mjs";
import CloseIcon from "../../../media/assets/CloseIcon.mjs";
import CheckIcon from "../../../media/assets/CheckIcon.mjs";
import AppAnnuncioIcon from "../../../media/assets/AppAnnuncioIcon.mjs";
import AppEditIcon from "../../../media/assets/AppEditIcon.mjs";
import AppModIcon from "../../../media/assets/AppModIcon.mjs";
import AppAdminIcon from "../../../media/assets/AppAdminIcon.mjs";

const prefix = "UserIndex";

const UserActive = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: appLib.currentUser(),
		};
		this.state.newname = this.state.user?.name ?? '';
		this.changeName = this.changeName.bind(this);
	}
	changeName() {
		const newName = this.state.newname.replace(/\t+/g,' ').trim();
		if ( ! newName ) return;
		const user = this.state.user;
		this.setState({ sending: true}, () => {
			appLib.api('auth/change-name', { name: newName }).then( res => {
				if ( res?.id ) {
					user.name = res.name;
					appLib.currentUser(res);
				}
			}).catch( err => {
				console.log(err);
			}).finally( () => {
				this.setState({ user: user, newname: user?.name, changing: false, sending: false });
			})
		});
	}
	render() {
		if ( ! this.state.user?.email ) return null;
		return (
			<div className={prefix+"-user-active"}>
				<strong className={"title"}>
					{ this.state.changing ? <AppEditIcon fill={"#0d6efd"}/> : <MailIcon /> }
					<span>{ this.state.user.email }</span>
				</strong>
				{ this.state.changing ? (
					<Form
						className={"namechange"}
						onSubmit={ e => {
							e.preventDefault();
							if ( this.state.sending || ! this.state.newname ) return;
							this.changeName();
						}}
					>
						<div className={"mt-2 mb-2"}>
							<InputGroup>
								<Input
									type={"text"}
									autoFocus={true}
									value={ this.state.newname }
									autoComplete={"nickname username"}
									onChange={ e => { this.setState({ newname: e.target.value }); }}
								/>
							</InputGroup>
						</div>
						<div>
							<ButtonGroup
								className="btn-icon"
							>
								<Button
									color={"warning"}
									type={"reset"}
									onClick={ () => this.setState({ changing: false })}
								>
									<i>
										<CloseIcon />
									</i>
									<b>
										<TextLabel value={"Cancel"} />
									</b>
								</Button>
								<Button
									type={"submit"}
									color={"primary"}
									disabled={ this.state.sending || ! this.state.newname }
								>
									<b style={{margin: "0 1rem"}}>
										<TextLabel value={"OK"} />
									</b>
									<i>
										<CheckIcon />
									</i>
								</Button>
							</ButtonGroup>
						</div>
					</Form>
				) : (
					<>
						<div
							className={"username"}
							onClick={()=>{ this.setState({newname: this.state.user.name ?? '', changing: true })}}
						>
							<span>«<strong>{ this.state.user.name }</strong>»</span>
						</div>
						<div className={"mt-2"}>
							<Button
								color={"danger"}
								className={"btn-icon me-2"}
								onClick={ () => Glob.trigger('my_user_deletion', true)}
							>
								<i>
									<TrashIcon />
								</i>
							</Button>
							<ButtonGroup
								className="btn-icon"
							>
								<Button
									color={"warning"}
									onClick={ appLib.logout }
								>
									<i>
										<LockOffIcon />
									</i>
									<b style={{margin: "0 1rem"}}>
										<TextLabel value={"Logout"} />
									</b>
								</Button>
								<Button
									color={"success"}
									onClick={()=>{ this.setState({newname: this.state.user.name ?? '', changing: true })}}
								>
									<b>
										<TextLabel value={"Edit"} />
									</b>
									<i>
										<AppEditIcon />
									</i>
								</Button>
							</ButtonGroup>
						</div>
					</>
				) }
				{ (!! (this.state.user?.moderator || this.state.user?.admin )) && (
					<div className={"privileges"}>
						{this.state.user?.moderator && <div><AppModIcon /><span><TextLabel value={"Moderator"} /></span></div> }
						{this.state.user?.admin && <div><AppAdminIcon /><span><TextLabel value={"Administrator"} /></span></div> }
					</div>
				)}
				<div className={"moreControls"}>
					<ButtonGroup
						className="btn-icon"
					>
						<Button
							color={"success"}
							onClick={ ()=>{ Glob.trigger('my_user_messages', true); }}
						>
							<b>
								<TextLabel value={"My ads"} />
							</b>
							<i>
								<AppAnnuncioIcon />
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</div>
		)
	}
}

export default UserActive;